import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// Login Redux States
import { CHECK_LOGIN, LOGOUT_USER, VERIFY_ADMIN } from './actionTypes';
import { apiError, loginUserSuccessful, logoutUserSuccess, verify_adminFail, verify_adminSuccess } from './actions';

// AUTH related methods
import { loginApi, logoutApi, verifyAdminApi } from './api';
import { clearProductsListStateStorage } from '../../../helpers/productsListStateStorage';

//If user is login then dispatch redux action's are directly from here.

function* loginUser({ payload: { user, history, rememberMe } }) {
    try {
        const response = yield call(loginApi, user)
        // localStorage.setItem("authUser", JSON.stringify(response.data.profile));
        if (rememberMe) {
            localStorage.setItem("token", JSON.stringify(response.data.token));
        } else {
            sessionStorage.setItem("token", JSON.stringify(response.data.token));
            localStorage.setItem("token", JSON.stringify(response.data.token));
            setTimeout(()=>{
                localStorage.removeItem("token")
            }, 30000000)
        }
        yield put(loginUserSuccessful(response));

        history('/dashboard');
    } catch (error) {
        yield put(apiError(error));
    }
}

function* logoutUser({ payload: { history } }) {
    try {

        const response = yield call(logoutApi);
        yield put(logoutUserSuccess(response));
        localStorage.removeItem('token');
        sessionStorage.removeItem('token')
        clearProductsListStateStorage();
        // history('/login');
    } catch (error) {
        yield put(apiError(""));
        localStorage.removeItem('token');
        sessionStorage.removeItem('token')
        clearProductsListStateStorage();
    }
}

function* verifyAdmin({ payload: { history } }) {
    try {
        const response = yield call(verifyAdminApi);
        if (response.code === "success") {
            yield put(verify_adminSuccess(response));
        } else {
            yield put(verify_adminFail(response));
            localStorage.removeItem('token');
            clearProductsListStateStorage();
            // yield put(push('/login'));
            return false
        }
    } catch (error) {
        yield put(apiError(error));
    }
}

export function* watchUserLogin() {
    yield takeEvery(CHECK_LOGIN, loginUser);
}

export function* watchUserLogout() {
    yield takeEvery(LOGOUT_USER, logoutUser);
}

function* loginSaga() {
    yield all([
        fork(watchUserLogin),
        fork(watchUserLogout),
    ]);
    yield takeEvery(VERIFY_ADMIN, verifyAdmin)

}

export default loginSaga;